import "./Services.module.css";
import BlipoliNavigation from "@/reusable_sections/Header";
import IndustrialHero from "./sections/IndustrialHero";
import CoreServicesGrid from "./sections/CoreServicesGrid";
import InfrastructureCta from "./sections/InfrastructureCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <BlipoliNavigation />
      <IndustrialHero />
      <CoreServicesGrid />
      <InfrastructureCta />
      <Footer />
    </div>;
}